import React from 'react';
import { Box, Typography } from "@mui/material";
import { Helmet } from "react-helmet-async";
import MyContainer from "../MyContainer";
import { useI18n } from "../../i8n/useI18n";

const PrivacyPage = () => {
    const { t } = useI18n();

    return (
        <MyContainer>
            <Helmet>
                <title>{t("privacyText.title")} | {t("brand.name")}</title>
            </Helmet>
            <Box sx={{ maxWidth: 720, py: 4 }}>
                <Typography variant="h2" sx={{ mb: 4 }}>{t("privacyText.title")}</Typography>

                <Typography variant="h5" sx={{ mb: 1, fontWeight: 700 }}>{t("privacyText.responsibleTitle")}</Typography>
                <Typography variant="body2" sx={{ mb: 4 }}>{t("privacyText.responsibleText")}</Typography>

                <Typography variant="h5" sx={{ mb: 1, fontWeight: 700 }}>{t("privacyText.purposeTitle")}</Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 4, lineHeight: 1.8 }}>
                    {t("privacyText.purposeText")}
                </Typography>

                <Typography variant="h5" sx={{ mb: 1, fontWeight: 700 }}>{t("privacyText.collectedDataTitle")}</Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 4, lineHeight: 1.8 }}>
                    {t("privacyText.collectedDataText")}
                </Typography>

                <Typography variant="h5" sx={{ mb: 1, fontWeight: 700 }}>{t("privacyText.thirdPartyTitle")}</Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 4, lineHeight: 1.8 }}>
                    {t("privacyText.thirdPartyText")}
                </Typography>

                <Typography variant="h5" sx={{ mb: 1, fontWeight: 700 }}>{t("privacyText.legalBasisTitle")}</Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 4, lineHeight: 1.8 }}>
                    {t("privacyText.legalBasisText")}
                </Typography>

                <Typography variant="h5" sx={{ mb: 1, fontWeight: 700 }}>{t("privacyText.storageDurationTitle")}</Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 4, lineHeight: 1.8 }}>
                    {t("privacyText.storageDurationText")}
                </Typography>

                <Typography variant="h5" sx={{ mb: 1, fontWeight: 700 }}>{t("privacyText.yourRightsTitle")}</Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 4, lineHeight: 1.8 }}>
                    {t("privacyText.yourRightsText")}
                </Typography>

                <Typography variant="caption" color="text.disabled" sx={{ display: "block", mt: 4 }}>
                    {t("privacyText.disclaimerText")}
                </Typography>
            </Box>
        </MyContainer>
    );
};

export default PrivacyPage;
